
/**
 * Create your own mat js 
 */

// loader
$( document ).ready(function() {
  if($('#custom-line-one').length) {
    let custom_tag = 'Nada';
      
    if ($('.mat-editor-button').length) {
  	$('.product-page--images-container').hide();
      
      // buton show hide
      $('.mat-editor-button').on('click', function() {
        $('#mat-custom-editor').show();
        $('.product-page--images-container').hide();
      });
      
      $('.image--container').on('click', function() {
        $('#mat-custom-editor').hide();
        $('.product-page--images-container').show();
      });
      
      // get what custom mat it is
      custom_tag = $('.copy').attr('data-custom-tag');
      
      // inital set up
      if(custom_tag == 'special') {
        $("#custom-line-two").datepicker({
          dateFormat: "dd.mm.y",
          changeMonth: true,
  	    changeYear: true,
          onClose: function () {
            setCustomLineTwo(custom_tag);
          }
        });
       
      }
    }
    
    // check for required fields
    if($('#custom-line-one').length) {
  	
      console.log(custom_tag);
      
      // hook up text update
      $('#custom-line-one').keyup(function() {
        setCustomLineOne(custom_tag);
      });
    }
    
    // check for required fields
    if($('#custom-line-two').length) {
  	$('#custom-line-two').keyup(function() {
        setCustomLineTwo(custom_tag);
      });
    }
    
    // check for required fields
    if($('#custom-line-three').length) {
  	$('#custom-line-three').keyup(function() {
        setCustomLineThree(custom_tag);
      });
    }
    
    // inital default
    setCustomLineOne(custom_tag, true);
    
    if ($('#setCustomLineTwo').length > 0) {
  	setCustomLineTwo(custom_tag, true);
    }
    
    if ($('#setCustomLineThree').length > 0) {
  	  setCustomLineThree(custom_tag, true)
    }
    
    // check for required fields for custom mat
    if($('#custom-font-one').length) {
      
      // custom fonts
      $('#custom-font-one').change(function() {
        setCustomFont('one');
        setCustomFont('two', 'one');
        setCustomFont('three', 'one');
      });
      
      $('#custom-font-two').change(function() {
        setCustomFont('two');
      });
      
      $('#custom-font-three').change(function() {
        setCustomFont('three');
      });
  
      $('#custom-position').change(function() {
        setCustomPosition();
      });
      
      // custom sizes
      $('#custom-font-size-one').change(function() {
        setCustomSize('one');
      });
      $('#custom-font-size-two').change(function() {
        setCustomSize('two');
      });
      $('#custom-font-size-three').change(function() {
        setCustomSize('three');
      });
      
      $('body').on('change', '#variant-listbox-option-0', function() {
        console.log('change')
        showMatBorder($(this).val());
      });
      // $('#variant-listbox-option-0').change(function() {
      //   showMatBorder($(this).val());
      // });
      
      setCustomFont('one');
      setCustomFont('two');
      setCustomFont('three');
  	setCustomPosition();
    }
  
    // catch form submit and validate custom fields
    $('#add').on('click', function(e) {
  	
      if( custom_tag == 'custom' ) { // orginal make your own mat
        
        if($('#custom-line-one').val() == '' && $('#custom-line-two').val() == '' && $('#custom-line-three').val() == '') {
          alert("Please add at least one line of text");
          e.preventDefault();
        }
  
      } else { // all others
      
        // validate custome fileds
        if($('#custom-line-one') && $('#custom-line-one').val() == '') {
    //       alert("please enter custom text for Line One");
          $('#custom-line-one').addClass('error-input').animate({
            scrollTop: $('#custom-line-one').offset().top
          }, 2000);
          e.preventDefault();
          return false;
        } else {
          $('#custom-line-one').removeClass('error-input')
        }
  
        // validate custome fileds
        if($('#custom-line-two') && $('#custom-line-two').val() == '') {
    //       alert("please enter custom text for Line two");
          $('#custom-line-two').addClass('error-input').animate({
            scrollTop: $('#custom-line-two').offset().top
          }, 2000);
          e.preventDefault();
          return false;
        } else {
          $('#custom-line-two').removeClass('error-input')
        }
  
        // validate custome fileds
        if($('#custom-line-three') && $('#custom-line-three').val() == '') {
    //       alert("please enter custom text for Line three");
          $('#custom-line-three').addClass('error-input').animate({
            scrollTop: $('#custom-line-three').offset().top
          }, 2000);
          e.preventDefault();
          return false;
        } else {
          $('#custom-line-three').removeClass('error-input')
        }
      }
  
      return true;
    });
  }

/**
 * Custom SKUs with fake size dropdown (eg: INITIAL CUSTOM DOORMAT)
 */
  if($('#variant-listbox-fake').length) {
    const fakedropdown = document.getElementById("variant-listbox-fake");
    const letter = document.getElementById("custom-line-one");
    const realdropdown = document.getElementById("variant-listbox");
    
    // update realdropdown from the combination of the fake and letter
    fakedropdown.addEventListener("change", function () {
      setRealVarientDropdown();
    });
    letter.addEventListener("keyup", function () {
      setRealVarientDropdown();
    })

    function setRealVarientDropdown() {
      let matchFound = false;
      if(letter.value != "") {
        console.log("letter", letter.value)
        console.log("fakedropdown", fakedropdown.value);
        console.log("realdropdown", realdropdown.value);

        // Find matching product - with letter
        let findValue = fakedropdown.value + ' - ' + letter.value;

        for (var i = 0; i < realdropdown.options.length; i++) {
          // console.log('search', realdropdown.options[i].text, findValue, realdropdown.options[i].text.search(findValue));
          if (realdropdown.options[i].text.search(findValue) !== -1) {
              realdropdown.selectedIndex = i;
              let uidropdown = document.getElementById("variant-listbox-option-0");
              uidropdown.selectedIndex = i;
              uidropdown.dispatchEvent(new Event('change'));
              matchFound = true;
              break;
          }
        }
      }

      // catch no product match, show out of stock message:
      if(!matchFound) {
        console.log('out of stock!');
        $('.quanity-cart-row').hide();
        $('.product-unavailable').show();
      }
      
      // without letter
      // if(matchFound == false) {
      //   findValue = fakedropdown.value;
      //     for (var i = 0; i < realdropdown.options.length; i++) {
      //     // console.log('search', realdropdown.options[i].text, findValue, realdropdown.options[i].text.search(findValue));
      //     if (realdropdown.options[i].text.search(findValue) !== -1) {
      //         realdropdown.selectedIndex = i;
      //         let uidropdown = document.getElementById("variant-listbox-option-0");
      //         uidropdown.selectedIndex = i;
      //         uidropdown.dispatchEvent(new Event('change'));
      //         matchFound = true;
      //         break;
      //     }
      //   }
      // }
      // console.log("set dropdown", realdropdown.value);

      
    }
  }

/**
 * DEAR checkout meta data 2 notes script
 */
  if($('.cart-table').length) {
    // hide the notes fields, but make sure they still get posted with the form
    $('.order-notes h3').hide();
    $('#cart-notes-area').hide();
    
    // do inital copy just to be safe
    copyOrdersToNotes();

    // triggers for when the user to submits the checkout page so that we catch any updates done between page load and submit (like deleting an item)
    // $("#shopify-section-cart > div > form > div:nth-child(2) > div.columns.large-7 > div.totals.columns > input.button").on('click', function () {
    //   copyOrdersToNotes();
    // });

    // $('#dynamic-checkout-cart').on('click','*', function () {
    //   copyOrdersToNotes();
    // });

    $('#shopify-section-cart > div > form').on('submit', function () {
        copyOrdersToNotes();
    });

    // catch triggers to afterpay and apple pay
    $(document).on("click", 'div[role=button]',function() {
      copyOrdersToNotes();
    })
    
    function copyOrdersToNotes() {
      // console.log('copyOrdersToNotes');
      
      let ordersToNotes = '|| ';
    
        $('.title').each(function(index) {
          let titleText = $( this ).text().trim().replace(/\t\t/gm, '/').replace(/\s\s/gm, '');
            console.log('td.title: ', titleText );
          if(titleText.replace(/\s/gm, '') != '' && titleText != 'Store' && titleText != 'Doormat Info' && titleText != 'Subscribe') {
            ordersToNotes += titleText.replace(/\//gm, ' > ') + " \n\n|| ";
          }
        });
    
      console.log('ordersToNotes', ordersToNotes);
      $('#cart-notes-area').val(ordersToNotes.trim().slice(0, -2));
    }
  }
  
}); // end dom



// FUNCTIONS
function setCustomLineOne(custom_tag, set_inital_value=false) {
  let value = $('#custom-line-one').val();
  
  if (set_inital_value && value == '') {
    if (custom_tag == 'custom') {
	    value = 'Customise';
    }
  }
  
  if (value == '') {

    switch(custom_tag) {
      case 'welcome':
        value = "Simpson's";
        break;
      case 'heart':
        value = 'R';
        break;
      case 'custom':
        $('#custom-line-one-output').hide();
        break;
      case 'initial-doormat':
        value = 'M';
        break;
      case 'initial-surname':
        value = 'A';
        break;
      case 'surname':
      case 'welcome-palm-tree':
        value = 'THE JOHNSONS';
        break;
      case 'welcome-mat':
        value = 'THE JONES FAMILY';
        break;
      case 'surname-script':
        value = 'Simpsons';
        break;
      case 'kenays-embossed':
        value = 'ANDOVER';
        break;
      case 'family-doormat':
        value = 'R';
        break;
      case 'double-border-inital':
      case 'black-double-border-inital':
        value = 'B';
        break;
      case 'couple-inital-embossed':
      case 'couple-inital-palm-tree':
        value = 'J';
        break;
      case 'crest-initial-semi-circle':
        value = 'M';
        break;
      case 'crest-address':
        value = '56';
        break;
      case 'our-place-doormat':
        value = '35';
        break;
      case 'welcome-doormat':
        value = 'THE BROWNS';
        break;
      case 'residence-doormat':
        value = 'Lattouf';
        break;
    }
    
    // if (custom_tag == 'welcome') {
	   //  value = "Simpson's";
    // }

    // if (custom_tag == 'heart') {
    //   value = 'R';
    // }
    
    // if (custom_tag == 'custom') {
    // 	$('#custom-line-one-output').hide();
    // }
    
    // if (custom_tag == 'initial-doormat') {
    // 	value = 'M';
    // }
    
    // if (custom_tag == 'initial-surname') {
    // 	value = 'A';
    // }
    
    // if (custom_tag == 'surname' || custom_tag == 'welcome-palm-tree') {
    // 	value = 'THE JOHNSONS';
    // }
    
    // if (custom_tag == 'welcome-mat') {
    // 	value = 'THE JONES FAMILY';
    // }
    
    // if (custom_tag == 'surname-script') {
    // 	value = 'Simpsons';
    // }
    
    // if (custom_tag == 'kenays-embossed') {
    // 	value = 'ANDOVER';
    // }
    
    // if (custom_tag == 'family-doormat') {
    // 	value = 'R';
    // }
    
    // if (custom_tag == 'double-border-inital') {
    // 	value = 'B';
    // }
    
    // if (custom_tag == 'couple-inital-embossed') {
    // 	value = 'J';
    // }
    
    // if (custom_tag == 'couple-inital-palm-tree') {
    // 	value = 'J';
    // }
    
    // if (custom_tag == 'crest-initial-semi-circle') {
    // 	value = 'M';
    // }
    
    // if (custom_tag == 'crest-address') {
    // 	value = '56';
    // }
    
    // if (custom_tag == 'our-place-doormat') {
    // 	value = '35';
    // }

    // if (custom_tag == 'welcome-doormat') {
    // 	value = 'THE BROWNS';
    // }
    
  }

  if (custom_tag == 'special') {
    value = 'The '+value;
  }
  
  if (custom_tag == 'family') {
    value = '&middot;  THE '+value+'  &middot;';
  }
  
  if (custom_tag == 'custom' && value != '') {
    $('#custom-line-one-output').show();
  }
  
  if(custom_tag == 'surname-script') {
    value = limit_chars($('#custom-line-one'), value);
  }
  
  // check for fit-text
  if (typeof $("#custom-line-one-output").data('fit-text') !== 'undefined') {
     fit_size($('#custom-line-one-output'), 8, value);
  }
  
  console.log(value);
  $('#custom-line-one-output').html(value);
}

function setCustomLineTwo(custom_tag, set_inital_value=false) {
  let value = $('#custom-line-two').val();
  
  if (set_inital_value && value == '') {
    if (custom_tag == 'custom') {
	    value = 'your mat';
    }
  }
  
  console.log(value);
  if (value == '') {
    if (custom_tag == 'special') {
    	value = getDate();
  	}
    
    if (custom_tag == 'heart') {
      value = 'J';
    }

    if (custom_tag == 'custom') {
    	$('#custom-line-two-output').hide();
    }
    
    if (custom_tag == 'couple-inital-embossed') {
    	value = 'J';
    }
    
    if (custom_tag == 'couple-inital-palm-tree') {
    	value = 'G';
    }
  }

  if (custom_tag == 'special') {
    value = 'Est.'+value;
  }
  
  if (custom_tag == 'custom' && value != '') {
    $('#custom-line-two-output').show();
  }
  
  // check for fit-text
  if($('#custom-line-two-output').attr('data-fit-text')) {
     fit_size($('#custom-line-two-output'), 5, value);
  }
  
  $('#custom-line-two-output').html(value);
}

function setCustomLineThree(custom_tag, set_inital_value=false) {
  let value = $('#custom-line-three').val();
  
  if (set_inital_value && value == '') {
	// set inital values here
  }
  
  
  console.log(value);
  if (value == '') {
    $('#custom-line-three-output').hide();
  } else {
    $('#custom-line-three-output').show();
  }

  // check for fit-text
  if($('#custom-line-three-output').attr('data-fit-text')) {
     fit_size($('#custom-line-three-output'), 5, value);
  }
  
  $('#custom-line-three-output').html(value);
}

function getDate() {
  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  let yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  } 
  if (mm < 10) {
    mm = '0' + mm;
  } 
  return dd + '.' + mm + '.' + yyyy; 
}

function setCustomFont(elementNumber, fontElementOverride=false) {
  let font = $('#custom-font-'+elementNumber).val();
  if( fontElementOverride !== false) {
    font = $('#custom-font-'+fontElementOverride).val();
    $('#custom-font-'+elementNumber).val(font)
  }
  $('#custom-line-'+elementNumber+'-output').removeClass();
  $('#custom-line-'+elementNumber+'-output').addClass(font);
}

function setCustomPosition() {
  const position = $('#custom-position').val();
  $('#custom-positioning').removeClass();
  $('#custom-positioning').addClass('wrap').addClass(position);
}

function setCustomSize(elementNumber) {
  const font = $('#custom-font-size-'+elementNumber).val();
  $('#font-size-'+elementNumber).removeClass();
  $('#font-size-'+elementNumber).addClass(font);
}

function showMatBorder(val) {
  console.log('showMatBorder', val, val.search('border'))
  if(val.search('border') !== -1) {
    $('.mat-custom-editor').css('background-image', 'url(//doormates.com.au/cdn/shop/t/34/assets/mat-border-overlay.png?v=154269720677286660511785891994)'); 
  } else {
   $('.mat-custom-editor').css('background-image', 'url(//doormates.com.au/cdn/shop/t/34/assets/mat-template.png?v=36499548067415208351785891994)');
  }
}

function fit_size(ele, min_size, str) {
  if( str.length > 0) {
    // save orginal size if not saved
    if (typeof ele.data('fit-text-org') === 'undefined') {
      ele.data('fit-text-org', ele.css('font-size'));
    }

    // reset size
    ele.css({ 'font-size': ele.data('fit-text-org') });

    // work out offset
    if(str.length > min_size) {
      // get current font size
      const font_size = ele.css('font-size').replace('px', '');
  //     console.log('font_size', font_size, ele.css('font-size'));

      // get offset number from the amount over min_size
      const offset = str.length - min_size;
  //     console.log('offset', offset);

      // reduce font size by the offset
      const chunk = font_size / 15; 
      const new_size = font_size - (offset * chunk);
  //     console.log('new_size', new_size);

      // update font-size
      ele.attr('style', 'font-size: '+new_size+'px !important');
    }
  }
}

function limit_chars(ele, str) {
  if( ele.val().length > 0) {
    str = str.replace(/[^a-zA-Z0-9\!\s]/gi, '')
  	ele.val(str);
  }
  return str;
}

